import React, { FC } from 'react';
import { SCUIGeneralModal } from '../../../../atomic/molecules';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PS_BS } from '../../productSearch.classes';

export const SCUIProductBatchSearchModal: FC<{
    open: boolean;
    onClose: any;
    orderNo: any;
    setOrderNo: any;
    listele?: any;
    text?: any;
}> = ({ open, onClose, orderNo, setOrderNo, listele, text }) => {
    const { t } = useTranslation();

    return (
        <SCUIGeneralModal
            rootClassName={PS_BS.modalRoot}
            paperClassName={PS_BS.modalPaper}
            titleClassName={PS_BS.modalTitle}
            closeIconButtonClassName={PS_BS.modalCloseButton}
            closeIconClassName={PS_BS.modalCloseIcon}
            width={'xs'}
            open={open}
            onClose={onClose}
            title={t('general.batchSearch')}
            functionButtonOnClick={listele}
            buttonText={t('general.search')}
        >
            <Grid className={PS_BS.modalBody} container sx={{ padding: '2rem' }}>
                <TextField
                    className={PS_BS.modalTextField}
                    sx={{ paddingBottom: '1rem' }}
                    label={text}
                    value={orderNo}
                    multiline
                    rows={10}
                    onChange={(event: any) => {
                        setOrderNo(event.target.value);
                    }}
                    slotProps={{ inputLabel: { shrink: true } }}
                    fullWidth
                />
            </Grid>
        </SCUIGeneralModal>
    );
};
